module.exports = __webpack_public_path__ + "img/attach.5e9b19b3.svg";